<script setup>
import {ref} from "vue";
import createTenantBikeStore from "./components/createTenantBikeStore/index.vue";
import router from "@/router/index.js";
import {addTherapistIgnore} from "@/api/therapist/ignoreTenant.js";
import {addBikeStoreIgnore} from "@/api/bikeStore/ignoreTenant.js";

// 加载状态
const loading = ref(false)
/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: "Coming Soon ...",
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null
  },
  tenantId: null,
  // 营业时间
  operatingHours: [{
    operatingTime: [],
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null
  }],
  nonSelfOperatedLink: null,
  referralOfficer: {
    name: null,
    phone: null
  },
  certificationType: null,
  partnerStores: [],
  serviceModeTypes: [],
  businessTypes: [],
  summary: null,
  summaryEn: null,
  description: null,
  descriptionImages: [],
  descriptionEn: null,
  descriptionEnImages: [],
  // 负责人信息
  contactName: null,
  phone: null,
  contactEmail: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  tagIdList: [],
  assistsOperation: true,
  storeCoverImage: null,
  photoList: [],
  storeDiscoverCoverImage: null
})
// 处理表单提交新建俱乐部
const handleCreateTenantBikeStore = async () => {
  try {
    loading.value = true
    await addBikeStoreIgnore(ruleForm.value)
    router.push({ path: "/listTenantBikeStore" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createTenantBikeStore v-model="ruleForm" @success="handleCreateTenantBikeStore"></createTenantBikeStore>
  </div>
</template>

<style scoped>

</style>
